import { datadogRum } from "@datadog/browser-rum";
import React from "react";
import ReactDom from "react-dom";
import App from "./App";
import WrapperProvider from "./contexts/WrapperProvider";
import { DATADOG_APPLICATION_ID, DATADOG_CLIENT_TOKEN, ENV, SERVICES_URL } from "./env";

if (ENV !== "local") {
  datadogRum.init({
    applicationId: DATADOG_APPLICATION_ID as string,
    clientToken: DATADOG_CLIENT_TOKEN as string,
    site: "us5.datadoghq.com",
    service: "best---sure-application",
    env: ENV,
    version: process.env.VERSION || "unknown",
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: "mask-user-input",
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    allowedTracingUrls: [SERVICES_URL],
    beforeSend: (event) => {
      if (event.type === "resource") {
        if (event.resource.url.match(/\.(m3u8|ts|mp4|webm)/)) {
          event.context.resourceCategory = "video";
        }
      }
      return true;
    },
  });

  datadogRum.setGlobalContextProperty("app", "best-umpire-sure");
  datadogRum.setGlobalContextProperty("team", "best-umpire");

  datadogRum.startSessionReplayRecording();
}

ReactDom.render(
  <WrapperProvider>
    <App />
  </WrapperProvider>,
  document.getElementById("sure-ui-app"),
);
